export default __webpack_public_path__ + "static/media/system-volume_01.fb476854.svg";